import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadTimer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(loadTimer);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <img
          src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=1920&q=85"
          alt="面道面馆"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      <div className={`hero-content ${isLoaded ? 'loaded' : ''}`}>
        <p className="hero-subtitle">始于1928 · 传承百年手艺</p>
        <h1 className="hero-title">
          <span className="title-line">一碗好面</span>
          <span className="title-line">匠心传承</span>
        </h1>
        <p className="hero-desc">精选北方面粉，手工拉制24遍<br />配以熬制12小时的骨汤</p>
        <div className="hero-buttons">
          <a href="#menu" className="btn-primary" onClick={(e) => scrollToSection(e, '#menu')}>品尝匠心</a>
          <a href="#about" className="btn-secondary" onClick={(e) => scrollToSection(e, '#about')}>了解更多</a>
        </div>
      </div>
      <div className="scroll-hint">
        <span>向下滚动</span>
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
